export enum AccountingType {
  REGULAR = 'regular',
  YEAR = 'year',
  MONTH = 'month',
  WEEK = 'week'
}
